// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EsJg9","logo":"Footer_logo__F+nFO"};